import { render } from "./SideBar.vue?vue&type=template&id=d32024bc&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=d32024bc&scoped=true&lang=css"
import "./SideBar.vue?vue&type=style&index=1&id=d32024bc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32024bc"]])

export default __exports__